import { useAuthStore } from '@/stores/auth';
import { useLocalStorageStore } from '@/stores/localStorage';
import { useGnbStore } from '@/stores/gnb';
import { syncDatadogUserFromClients } from '@/lib/useSessionHandler';
/*

    LocalStorage에 저장 된 정보가 있다면 Vuex에 저장합니다.
    main.ts에서 store load 후 호출 되어야 합니다.

*/
export default function install() {
  const getLoaclStorage = localStorage.getItem('dpost-v1');

  if (!getLoaclStorage) return;

  const fetchData = JSON.parse(getLoaclStorage as string);

  const authStore = useAuthStore();
  authStore.updateSessionToken(fetchData.auth.sessionToken);
  authStore.updateClientInfo(fetchData.auth.clientInfo);
  authStore.updateCenterInfo(fetchData.auth.centerInfo);
  authStore.updateMarketingAgreement(fetchData.auth.marketing);

  // 재방문·새로고침 시 success()를 거치지 않음 — GNB API 선호출 + Datadog setUser
  if (fetchData.auth.sessionToken) {
    syncDatadogUserFromClients();
    useGnbStore().loadGnbMenu();
  }

  //로컬스토리지에 오늘 접수공지팝업 표시 데이터 저장
  const getPopupLocalStorage = localStorage.getItem('popupOpenFrom');

  if (getPopupLocalStorage) localStorage.setItem('popupOpenFrom', getPopupLocalStorage);
  else useLocalStorageStore().savePopupDataLocalStorage();
}
